<template>
  <div id="barChart"></div>
</template>
<script>
import ApexCharts from "apexcharts";
export default {
  name: "BarChart",
  props: {
    labels: {
      type: Array,
    },
    assets: {
      type: Array,
    },
    liabilities: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    loadChart() {
      const self = this;
      console.log(this.assets, this.liabilities, this.labels);
      var options = {
        series: [
          {
            name: "Assets",
            // data: [44, 55, 41, 64, 22, 43, 21],
            data: self.assets,
          },
          {
            name: "Liabilities",
            // data: [53, 32, 33, 52, 13, 44, 32],
            data: self.liabilities,
          },
        ],
        chart: {
          type: "bar",
          height: this.$vuetify.breakpoint.smAndUp ? 350 : 250,
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              position: "top",
            },
          },
        },
        dataLabels: {
          enabled: false,
          // offsetX: -6,
          // style: {
          //   fontSize: "12px",
          //   colors: ["#fff"],
          // },
        },
        stroke: {
          show: true,
          width: 1,
          colors: ["#fff"],
        },
        tooltip: {
          shared: true,
          intersect: false,
        },
        xaxis: {
          // categories: [2001, 2002, 2003, 2004, 2005, 2006, 2007],
          categories: this.labels,
        },
      };

      var chart = new ApexCharts(document.querySelector("#barChart"), options);
      chart.render();
    },
  },
  mounted() {
    this.loadChart();
  },
};
</script>
